import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useAuth } from '../context/AuthContext';
import {
  NOTIFICACOES_POR_USUARIO,
  NotificacoesPorUsuarioData,
  NotificacoesPorUsuarioVars,
  Notificacao,
  MARCAR_NOTIFICACOES_LIDAS,
  MarcarNotificacoesLidasData,
} from '../services/notificacaoService';
import { TipoNotificacao } from '../utils/TipoNotificacao';

const formatDate = (value: string) =>
  new Date(value).toLocaleDateString('pt-BR') + ' ' +
  new Date(value).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

const Notification: React.FC = () => {
  const auth = useAuth();
  const user =
    (auth?.user as any) ||
    (typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem('user') || 'null')
      : null);
  const usuarioId = user?.id ?? '';

  const [page, setPage] = useState(0);
  const size = 5;

  const { data, loading, error } = useQuery<
    NotificacoesPorUsuarioData,
    NotificacoesPorUsuarioVars
  >(NOTIFICACOES_POR_USUARIO, {
    variables: { page, size },
    fetchPolicy: 'no-cache',
  });

  const [marcarTodasLidas] = useMutation<MarcarNotificacoesLidasData>(
    MARCAR_NOTIFICACOES_LIDAS
  );

  useEffect(() => {
    marcarTodasLidas();
  }, [marcarTodasLidas]);

  const totalPages = data?.notificacoesPorUsuario.totalPages ?? 0;

  const [notifications, setNotifications] = useState<Notificacao[]>([]);

  useEffect(() => {
    if (data?.notificacoesPorUsuario.items) {
      setNotifications(data.notificacoesPorUsuario.items);
    }
  }, [data]);

  const textoNotificacao = (TipoNotificacao: string) => {
    switch (TipoNotificacao) {
      case 'NOVO_TORNEIO':
        return 'Novo torneio criado.';
      case 'POST_TORNEIO':
        return 'criou uma nova publicação.';
      case 'POST_USUARIO':
        return 'criou uma nova publicação.';
      case 'COMENTARIO_POST':
        return 'comentou em sua publicação.';
      case 'CURTIDA_POST':
        return 'curtiu sua publicação.';
      case 'CURTIDA_COMENTARIO':
        return 'curtiu seu comentário.';
      case 'SEGUINDO':
        return 'começou a seguir você.';
      case 'DOCUMENTO_LIGA_ALTERADO':
        return 'alterou documentos da liga.';
      case 'INSCRICAO_POR_TERCEIRO':
        return 'inscreveu você em um torneio.';
      case 'FILA_ESPERA_PROMOVIDA':
        return 'Sua inscrição saiu da fila de espera!';
      case 'INSCRICAO_CANCELADA':
        return 'Sua inscrição foi cancelada.';
      case 'INSCRICAO_CRIADA':
        return 'Nova inscrição realizada.';
      case 'INSCRICAO_PAGA':
        return 'Pagamento de inscrição confirmado.';
      case 'PARTIDA_FINALIZADA':
        return 'Partida finalizada.';
      default:
        return 'notificação desconhecida';
    }
  }


  if (loading) return <div>Carregando...</div>;
  if (error) return <div className="alert alert-danger">Erro ao carregar notificações.</div>;

  return (
    <div>
      <ul className="list-group mb-3">
        {notifications.map((n) => (
          <li
            key={n.id}
            className={`list-group-item d-flex align-items-start ${!n.lida ? 'bg-light' : ''}`}
          >
            <img
              src={n.usuarioAutor?.imagemUrl || '/assets/images/user.png'}
              alt={n.usuarioAutor?.nome || 'Autor Desconhecido'}
              className="rounded-circle me-3"
              style={{ width: 40, height: 40 }}
            />
            <div className="flex-grow-1">
              <div className="fw-bold">
                {n.usuarioAutor?.nome}{' '}
                <span className="fw-500">{textoNotificacao(n.tipo || '')}</span>
              </div>
              <div>{n.mensagem}</div>
              <div>
                <small className="text-muted">@{n.usuarioAutor?.username}</small>
              </div>
              <small className="text-muted">
                {formatDate(n.criadoEm)}
              </small>
            </div>
          </li>
        ))}
      </ul>
      <div className="d-flex justify-content-between">
        <button
          className="btn btn-primary text-white btn-sm"
          disabled={page === 0}
          onClick={() => setPage((p) => p - 1)}
        >
          Anterior
        </button>
        <span>
          Página {page + 1} de {totalPages}
        </span>
        <button
          className="btn btn-primary btn-sm text-white"
          disabled={page + 1 >= totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Próxima
        </button>
      </div>
    </div>
  );
};

export default Notification;
